module.exports = __webpack_public_path__ + "img/computer.1c85f208.png";